import { Component, inject } from '@angular/core';
import { NOTIFICATION_TEXT } from '../../../core/constants/notification.constants';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-notification-banner',
  imports: [],
  templateUrl: './notification-banner.html',
  styleUrl: './notification-banner.scss',
})
export class NotificationBanner {
  protected readonly notificationService = inject(NotificationService);
  protected readonly text = NOTIFICATION_TEXT;
}
